import { ChevronLeft } from '@griply/assets';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Colors, IconButton } from 'shared/components/ui/icon-button';

import * as Styled from './today-section-header.style';

export type TodaySectionHeaderProps = {
  collapsed: boolean;
  onToggle: () => void;
};

export const TodaySectionHeader: React.FC<TodaySectionHeaderProps> = ({
  collapsed,
  onToggle,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.HeaderContainer>
      <Typography variant="h6" component="span">
        {t('pages.today.title')}
      </Typography>
      <IconButton
        icon={ChevronLeft}
        onClick={onToggle}
        rotation={collapsed ? 0 : -90}
        color={Colors.Default}
      />
    </Styled.HeaderContainer>
  );
};
